<footer class="border-t-2 border-slate-200 bg-slate-100/80 py-5">
  <div class="mx-auto flex max-w-7xl flex-col gap-2 px-4 sm:flex-row sm:items-center sm:justify-between">
    <p class="text-sm font-medium text-slate-700">
      &copy; {{ year() }} UPTCF. All rights reserved.
    </p>

    <div class="flex flex-wrap items-center gap-4">
      <span class="text-sm font-semibold text-slate-700">联系我们</span>
      <!-- <a href="mailto:uptcf@hotmail.com"
        class="inline-flex items-center justify-center rounded-md p-2 text-slate-500 transition-colors hover:bg-slate-200 hover:text-blue-600"
        aria-label="Email uptcf@hotmail.com"
        title="发送邮件">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
      </a> -->

      @if (auth.isAuthenticated()) {
      <button (click)="openMessageDialog()"
        class="inline-flex items-center justify-center rounded-md p-2 text-slate-500 transition-colors hover:bg-slate-200 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        aria-label="给我留言"
        title="留言">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>
      }

      <button type="button" (click)="toggleWechatQR()"
        class="inline-flex items-center justify-center rounded-md p-2 text-slate-500 transition-colors hover:bg-slate-200 hover:text-[#07C160] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        title="添加微信小助手"
        aria-label="添加微信小助手">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.44-2.687 3.877-1.78 6.465.295.013.582.041.869.041 4.339 0 7.957-2.739 8.868-6.4.078-.246.12-.496.12-.746 0-1.592-.796-3.042-2.104-4.054-1.308-1.012-2.693-1.563-4.493-1.092z"/>
        </svg>
      </button>
    </div>
  </div>
</footer>

@if (showWechatQR()) {
<div class="fixed inset-0 z-[100] flex items-end justify-center pb-24" (click)="closeWechatQR()" role="dialog"
  aria-modal="true" aria-label="微信小助手二维码">
  <div class="animate-grow-up-from-bottom rounded-xl border-4 border-slate-200 bg-white p-4 shadow-xl" (click)="$event.stopPropagation()" role="document">
    <p class="mb-3 text-center text-sm font-medium text-slate-700">添加微信小助手</p>
    <img src="/wechatQR.png" alt="微信小助手二维码" class="h-48 w-48 rounded-lg object-contain" />
  </div>
</div>
}

@if (showMessageDialog()) {
<div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" (click)="closeMessageDialog()" role="dialog"
  aria-modal="true" aria-labelledby="message-dialog-title">
  <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" (click)="$event.stopPropagation()" role="document">
    <h2 id="message-dialog-title" class="mb-4 text-lg font-semibold text-slate-900">给我留言</h2>
    <div class="space-y-4">
      <div>
        <label for="footer-message-email" class="mb-1 block text-sm font-medium text-slate-700">邮箱</label>
        <input id="footer-message-email" type="email" [value]="email()"
          (input)="email.set($any($event.target).value)" placeholder="请输入邮箱"
          class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
      </div>
      <div>
        <label for="footer-message-subject" class="mb-1 block text-sm font-medium text-slate-700">主题</label>
        <input id="footer-message-subject" type="text" [value]="subject()"
          (input)="subject.set($any($event.target).value)" placeholder="请输入主题"
          class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
      </div>
      <div>
        <label for="footer-message-description" class="mb-1 block text-sm font-medium text-slate-700">内容</label>
        <textarea id="footer-message-description" [value]="description()"
          (input)="description.set($any($event.target).value)" placeholder="请输入留言内容" rows="5"
          class="w-full resize-y rounded-md border border-slate-300 px-3 py-2 text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"></textarea>
      </div>
    </div>
    <div class="mt-6 flex justify-end gap-3">
      <button (click)="closeMessageDialog()" [disabled]="isSending()"
        class="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50">
        取消
      </button>
      <button (click)="sendMessage()" [disabled]="isSending() || !email().trim() || !subject().trim() || !description().trim()"
        class="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50">
        @if (isSending()) {
        <span class="inline-flex items-center gap-2">
          <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          发送中...
        </span>
        } @else {
        发送
        }
      </button>
    </div>
  </div>
</div>
}
